// src/lib/formatTime.ts
/** 75 → "1:15", 3725 → "1:02:05" with the locale's digits (e.g. "۱:۱۵" in fa). */
export function formatTime(seconds: number, locale = "en"): string {
  const total = Math.max(0, Math.floor(Number.isFinite(seconds) ? seconds : 0));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const nf = new Intl.NumberFormat(locale, { useGrouping: false });
  const two = new Intl.NumberFormat(locale, {
    minimumIntegerDigits: 2,
    useGrouping: false,
  });
  return h
    ? `${nf.format(h)}:${two.format(m)}:${two.format(s)}`
    : `${nf.format(m)}:${two.format(s)}`;
}
